<template>
  <button
    :type="type"
    :disabled="disabled"
    class="rounded-sm p-4 text-sm leading-none font-medium"
    :class="{
      'active:scale-[0.99]': !disabled,
      'button-primary': variant === 'primary' && !ignoreBranding,
      'button-primary-no-branding': variant === 'primary' && ignoreBranding,
      'button-secondary': variant === 'secondary' && !ignoreBranding,
      'button-secondary-no-branding': variant === 'secondary' && ignoreBranding,
      'button-error': variant === 'error',
      'button-muted': variant === 'muted',
    }"
  >
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import type { InputButtonVariant } from "@/types/CommonTypes";

const {
  type = "button",
  disabled = false,
  variant = "primary",
  ignoreBranding = false,
} = defineProps<{
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?: InputButtonVariant;
  ignoreBranding?: boolean;
}>();
</script>

<style scoped>
.button-primary-no-branding {
  background-color: var(--color-primary);
  color: #ffffff;
}

.button-secondary-no-branding {
  background-color: rgba(55, 105, 214, 0.1);
  color: var(--color-primary);
}

.button-primary {
  background-color: var(--branding-button);
  color: var(--branding-button-text);
  box-shadow: 0 4px 4px color-mix(in srgb, var(--branding-button) 25%, transparent);
}

.button-secondary {
  background-color: color-mix(in srgb, var(--branding-button) 12%, transparent);
  color: var(--branding-button);
}

.button-error {
  background-color: rgba(255, 89, 94, 0.1);
  color: #e51d23;
}

.button-muted {
  background-color: #ffffff;
  color: #868d9c;
  border: 2px solid #ebeef5;
}

button:disabled {
  background-color: #f1f4f7 !important;
  color: #c2c6cd !important;
  border-color: #c2c6cd !important;
  box-shadow: none !important;
}
</style>
